import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';
import { BANKS_IDS } from 'constants/banks';

import { OFFER_NOTE_TEXTS } from '../config/offerNote.texts';
import type { IOfferNoteData } from '../types';

import { generateLinks } from './generateLinks';

// eslint-disable-next-line max-statements, complexity
export const createOfferNoteDataFromPreApprovalMplOffer = (offer: MPLPreApprovalOffer): IOfferNoteData | null => {
  if (offer?.status === 'pending' || offer?.description || (offer?.preApprovalOfferId && offer?.buttonLink)) {
    return null;
  }

  if (offer.apiStatus === 'Queued') {
    return generateLinks(OFFER_NOTE_TEXTS.queued, []);
  }

  if (offer.apiStatus === 'Issued') {
    return OFFER_NOTE_TEXTS.credit.issued;
  }

  if (offer.apiStatus === 'Accepted') {
    return generateLinks(
      {
        ...OFFER_NOTE_TEXTS.credit.accepted,
        buttonLabel: OFFER_NOTE_TEXTS.credit.accepted.buttonLabel,
      },
      [],
    );
  }

  if (offer.apiStatus === 'PreApproved') {
    return generateLinks(OFFER_NOTE_TEXTS.credit.preapproved, []);
  }

  if (offer.apiStatus === 'Approved') {
    return generateLinks(OFFER_NOTE_TEXTS.credit.approved, []);
  }

  if (offer.apiStatus === 'Refused' || offer.apiStatus === 'Failed') {
    return OFFER_NOTE_TEXTS.credit.refused;
  }

  if (offer.isAlreadySentFromSameBank) {
    if (offer.organizationNewId === BANKS_IDS.OTKRITIE) {
      return generateLinks(OFFER_NOTE_TEXTS.credit.alreadySentOtkritie, []);
    }
    return generateLinks(OFFER_NOTE_TEXTS.credit.alreadySent, []);
  }

  return null;
};
